import {
    SET_USER_DETAILS,
    SET_USER_BILLING_DETAILS,
    SET_USER_CARD_DETAILS,
    SET_USER_WORKOUT_HISTORY,
    SET_USER_SURVEY,
    SET_FAVORITES_IDS,
    SET_FINISHED_WORKOUTS_IDS,
    SET_LATEST_SURVEY_SCORES,
    SET_USER_CHILD_DETAILS,
    SET_SELECTED_PROGRAM,
    SET_USER_ALL_WORKOUT_HISTORY,
    SET_USER_ALL_WORKOUT_HISTORY_WITH_ARCHIVED,
    SET_SURVEY_QUESTIONS,
    SET_SELECTED_PROGRAMS,
    SET_USER_NOTIFICATIONS,
    SET_ACCOUNT_DETAILS,
    SET_INVITATION_DETAILS,
    SET_PATIENT_EMAIL_DETAILS,
    SET_SURVEY_GOALS,
} from "./types";

import { SET_FAVORITE_WORKOUTS, SET_FAVORITE_EXERCISES } from "../favorite/types";
import { SET_PROGRAM_WORKOUTS } from "../program/types";

import { GetWorkoutDetails } from "../workout/actions";
import { apiCallV2, servicesAPICall } from "../../../utils/api";
import { callSocket } from "../../../utils/socket";
import { checkIfRedoSurvey, checkImpactFrag, checkIfUsingMobileApp, logoutAndRedirectMain } from "../../../utils/userResource";
import { removeItemInArray } from "../../../utils";

export const LogoutAndRedirect = (navigate) => async (dispatch, getState) => {
    logoutAndRedirectMain(navigate);
};

export const LoadUserData =
    (force = false) =>
        async (dispatch, getState) => {
            const { account } = getState().User;

            if (!(account?.user?.hasOwnProperty("email_address") && account?.user?.hasOwnProperty("id")) || force) {
                const resProfile = await apiCallV2("GET", "load-user-info", "", localStorage.getItem("access-token"), "", false);

                if (resProfile.status == 200) {
                    localStorage.setItem(
                        "indi-new-user-details",
                        JSON.stringify({
                            name: {
                                first: resProfile.data.data.first_name,
                                last: resProfile.data.data.last_name,
                            },
                        })
                    );

                    localStorage.setItem("launchDate", resProfile.data.data.launchDate);
                    localStorage.setItem("requirement_status", resProfile.data.data.requirement_status);

                    dispatch({
                        type: SET_USER_DETAILS,
                        details: {
                            ...resProfile.data.data,
                        },
                    });

                    if (resProfile.data.data.child_user) {
                        const resChildProfile = await apiCallV2("GET", "load-user-info", "", localStorage.getItem("access-token"), {
                            userID: resProfile.data.data.child_user,
                        });

                        if (resChildProfile.status == 200) {
                            dispatch({
                                type: SET_USER_CHILD_DETAILS,
                                details: {
                                    ...resChildProfile.data.data,
                                },
                            });
                        }
                    }
                }
            } else {
            }
        };

export const LoadFavorites = () => async (dispatch, getState) => {
    const { favorites } = getState().User;

    if (!favorites) {
        const res = await apiCallV2("GET", "get-all-favorites-ids", "", localStorage.getItem("access-token"));

        if (res?.status == 200) {
            dispatch({
                type: SET_FAVORITES_IDS,
                data: res?.data.data,
            });
        }
    } else {
    }
};

export const LoadFinishedWorkoutsIDs = () => async (dispatch, getState) => {
    const { allFinished } = getState().User;

    if (!allFinished) {
        const res = await apiCallV2("GET", "get-all-finished-workouts-ids", "", localStorage.getItem("access-token"));

        if (res?.status * 1 == 200) {
            dispatch({
                type: SET_FINISHED_WORKOUTS_IDS,
                data: res?.data.data.workouts,
            });
        }
    } else {
    }
};

export const UpdateFavorites =
    (videoID, isFavourite, type = "workout") =>
        async (dispatch, getState) => {
            let { workouts, exercises } = getState().User.favorites;

            if (type === "workout") {
                if (isFavourite) {
                    workouts.push({ workout_id: videoID });
                } else {
                    workouts = workouts.filter((i) => i.workout_id !== videoID);
                }
            } else if (type === "exercise") {
                if (isFavourite) {
                    exercises.push({ exercise_id: videoID });
                } else {
                    exercises = exercises.filter((i) => i.exercise_id !== videoID);
                }
            }

            dispatch({
                type: SET_FAVORITES_IDS,
                data: {
                    workouts: workouts,
                    exercises: exercises,
                },
            });
        };

export const LoadUserBillingData = () => async (dispatch, getState) => {
    const subscriptionRes = await apiCallV2("GET", "get-billing-details", "", localStorage.getItem("access-token"));

    if (subscriptionRes?.status == 200) {
        dispatch({
            type: SET_USER_BILLING_DETAILS,
            details: {
                ...subscriptionRes?.data.data,
            },
        });
    }
};

export const SetUserDetails = (details) => (dispatch) => {
    dispatch({
        type: SET_USER_DETAILS,
        details: details,
    });
};

export const CheckPassword = (password) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "check-password",
        {
            password: password,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200 && res?.data.status == 200) {
        return {
            match: true,
        };
    } else {
        return {
            match: false,
        };
    }
};

export const ChangePassword = (password) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "change-password",
        {
            password: password,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200 && res?.data.status == 200) {
        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const UpdateUserInfo = (info) => async (dispatch, getState) => {
    const { account } = getState().User;

    const res = await apiCallV2(
        "POST",
        "update-profile",
        {
            ...info,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200 && res?.data.status == 200) {
        dispatch({
            type: SET_USER_DETAILS,
            details: {
                ...account?.user,
                dob: info.dob,
                email_address: info.emailAddress,
                gender: info.gender,
                first_name: info.name.first,
                last_name: info.name.last,
                user_name: info.username,
            },
        });

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const UpdateUserPlan = (info) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "update-user-plan",
        {
            ...info,
        },
        localStorage.getItem("access-token")
    );
    if (res?.status == 200 && res?.data.status == 200) {
        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const CancelSubscription = (info) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "cancel-subscription",
        {
            ...info,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200 && res?.data.status == 200) {
        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const ReactivateSubscription = (info) => async (dispatch, getState) => {
    const res = await apiCallV2("POST", "reactivate-subscription", {}, localStorage.getItem("access-token"));

    if (res?.status == 200 && res?.data.status == 200) {
        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const UpdateBilling = (info) => async (dispatch, getState) => {
    const { billing } = getState().User;

    const res = await apiCallV2(
        "POST",
        "/update-billing-details",
        {
            ...info,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200 && res?.data.status == 200) {
        dispatch({
            type: SET_USER_BILLING_DETAILS,
            details: {
                ...billing,
                cardNumber: res?.data.data.number,
                cardType: res?.data.data.cardType,
                cardOwner: {
                    first: res?.data.data.name.first,
                    last: res?.data.data.name.last,
                },
                postal: res?.data.data.postal,
            },
        });

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const HasLiveSubscription =
    (token = null) =>
        async (dispatch, getState) => {
            const res = await apiCallV2("GET", "has-live-subscription", "", localStorage.getItem("access-token"), undefined, false);

            return res ? res?.data.data.hasLiveSubscription : false;
        };

export const CheckIfRedoSurvey = () => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "get-survey-dates", "", localStorage.getItem("access-token"), undefined, false);

    if (res?.status == 200 && res?.data.status == 200) {
        let redo = false;
        const dates = res?.data.data;

        if (dates.length > 0) {
            localStorage.setItem("goal_ids", JSON.stringify([dates[0].goal1, dates[0].goal2, dates[0].goal3]));

            const first = new Date(dates[0].created_at);

            const latest = new Date(dates[dates.length - 1].created_at);

            const currDate = new Date();

            const a30_days = 1000 * 60 * 60 * 24 * 30;

            const monthsFirst = Math.floor(Number((currDate - first) / a30_days)) * 1;
            const monthsLatest = Math.floor(Number((currDate - latest) / a30_days)) * 1;

            if (monthsLatest > 0) {
                if (monthsFirst % 3 === 0) {
                    redo = {
                        val: true,
                        type: "full",
                    };
                } else {
                    redo = {
                        val: true,
                        type: "half",
                    };
                }
            }
        }

        return redo;
    }
};

export const GetCardDetails = () => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "get-card-details", "", localStorage.getItem("access-token"));

    if (res?.status == 200 && res?.data.status == 200) {
        dispatch({
            type: SET_USER_CARD_DETAILS,
            details: {
                ...res?.data.data,
            },
        });
    }
};

export const GetWorkOutHistory = () => async (dispatch, getState) => {
    const { workoutHistory } = getState().User;
    // if (!workoutHistory || workoutHistory?.length == 0) {
    const res = await apiCallV2("GET", "get-workout-history", "", localStorage.getItem("access-token"), undefined, false);

    if (res?.status == 200 && res?.data.status == 200) {
        dispatch({
            type: SET_USER_WORKOUT_HISTORY,
            list: [...res?.data.data.workouts],
        });
    }

    // } else {
    // }
};

export const GetSurveyHistory =
    (bypass = false) =>
        async (dispatch, getState) => {
            const { survey } = getState().User;

            if (survey.answers.length == 0 || bypass) {
                const res = await apiCallV2("GET", "get-user-survey-history", "", localStorage.getItem("access-token"));

                if (res?.status == 200 && res?.data.status == 200) {
                    dispatch({
                        type: SET_USER_SURVEY,
                        details: { ...res?.data.data },
                    });
                }
            } else {
            }
        };

export const GetSignUpInitialDetail = (token) => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "load-user-info", "", token);

    if (res?.status === 200 && res?.data.status === 200) {
        localStorage.setItem("launchDate", res?.data.data.launchDate);

        return res?.data.data;
    } else if (res?.status === 400) {
        return res?.data.message;
    } else {
        return null;
    }
};

export const AddFinishedWorkoutID = (video) => async (dispatch, getState) => {
    let { allFinished, workoutHistory } = getState().User;
    let found = false,
        found2 = false;

    allFinished = allFinished ? allFinished : [];
    workoutHistory = workoutHistory ? workoutHistory : [];

    for (let x = 0; x < allFinished.length; x++) {
        if (allFinished[x].workout_id === video.workout_id) {
            found = true;
            break;
        }
    }

    for (let x = 0; x < workoutHistory.length; x++) {
        if (workoutHistory[x].workout_id === video.workout_id) {
            found2 = true;
            break;
        }
    }

    if (!found) {
        dispatch({
            type: SET_FINISHED_WORKOUTS_IDS,
            data: [...allFinished, { workout_id: video.workout_id }],
        });
    }

    if (!found2) {
        dispatch({
            type: SET_USER_WORKOUT_HISTORY,
            list: [video, ...workoutHistory],
        });
    }
};

export const LoadLatestSurveyScores = () => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "get-latest-survey-scores", "", localStorage.getItem("access-token"));

    if (res?.status === 200) {
        const { surveyQuestions } = getState().User;

        dispatch({
            type: SET_LATEST_SURVEY_SCORES,
            data: res?.data.data[0],
        });
        return true;
    } else {
        return false;
    }
};

export const AddPlusOne = (payload) => async (dispatch, getState) => {
    const { account } = getState().User;
    const res = await apiCallV2(
        "POST",
        "user-add-plus-one",
        {
            ...payload,
            company: account?.user?.company,
            companyName: account?.user?.name,
            launchDate: account?.user?.launchDate,
            parentUser: {
                id: account?.user?.id,
                first_name: account?.user?.first_name,
                last_name: account?.user?.last_name,
            },
        },
        localStorage.getItem("access-token")
    );

    if (res?.status === 200 && res?.data.status == 200) {
        dispatch({
            type: SET_USER_DETAILS,
            details: {
                ...account?.user,
                child_user: res?.data.user_id,
                child_user_info: res?.data.user,
            },
        });

        const resPurchase = await apiCallV2(
            "POST",
            "create-subscription",
            {
                first_name: payload.firstName,
                last_name: payload.lastName,
                currency: "USD",
                plan_id: "",
                billing_zip: "",
                coupon_code: [],
                startDate: new Date(account?.user?.launchDate),
                renewal: false,
            },
            res?.data.token
        );

        if (resPurchase.status == 200) {
            return {
                success: true,
                message: "",
                isValidNumber: res?.data.numberStatus.success,
            };
        } else {
            return {
                success: false,
                message: "Failed to subscribe user to company plan.",
            };
        }
    } else if (res?.status === 409) {
        if (res?.data === "Your email is already linked to INDI.") {
            return {
                success: false,
                message: res?.data,
            };
        } else {
            return {
                success: false,
                message: res?.message,
            };
        }
    } else {
        return {
            success: false,
            message: res?.data.message.sqlMessage,
        };
    }
};

export const RevokePlusOneUser = (userID, email) => async (dispatch, getState) => {
    const { account } = getState().User;

    const res = await apiCallV2("POST", "admin/user/expire-user", {
        user_id: userID,
        reason: "Revoked by Parent User",
        email_address: email,
    });

    if (res?.data.status === 200) {
        dispatch({
            type: SET_USER_DETAILS,
            details: {
                ...account?.user,
                child_user_info: {
                    ...account?.user?.child_user_info,
                    status: 0,
                },
            },
        });

        return true;
    } else {
        return false;
    }
};

export const ConnectImpactAccount = () => async (dispatch, getState) => {
    const { account } = getState().User;

    const res = await apiCallV2("GET", "get-impact-partner-data", {}, localStorage.getItem("access-token"), {
        email: account?.user?.email_address,
    });

    if (res?.data.status == 200) {
        dispatch({
            type: SET_USER_DETAILS,
            details: {
                ...account?.user,
                impact_id: res?.data.data.Id,
            },
        });
        return {
            success: true,
        };
    } else if (res?.data.status == 204) {
        return {
            success: false,
        };
    }
};

export const DeleteAccount = (now) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "delete-account",
        {
            now: now,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200) {
        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const AmbassadorSendInvite = (payload) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "ambassador-send-invite",
        {
            ...payload,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status === 200 && res?.data.status == 200) {
        const points = res?.data.data.response.split("-");

        if (points.length === 3) {
            return {
                success: true,
            };
        } else {
            let msg = "";
            if (points.indexOf("INDI")) {
                msg = "Unable to invite user.";
            } else if (points.indexOf("EMAIL")) {
                msg = "Unable to email invite.";
            } else if (points.indexOf("EMAIL")) {
                msg = "Unable to add user to contacts ";
            }

            return {
                success: false,
                msg: msg,
            };
        }
    } else {
        return {
            success: false,
            msg: "Failed to invite user.",
        };
    }
};

export const ResendInvitation = (type, number, email, company) => async (dispatch, getState) => {
    const { account } = getState().User;

    const res = await apiCallV2(
        "POST",
        "resend-invitation",
        {
            type: type,
            number: number,
            email: email,
            user: account?.user,
            company: company,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status === 200 && res?.data.status == 200) {
        return {
            success: true,
        };
    } else if (res?.status === 409) {
        return {
            success: false,
            message: res?.message,
        };
    } else {
        return {
            success: false,
            message: "Failed",
        };
    }
};

export const AddProgram = (programID, level) => async (dispatch, getState) => {
    const { account } = getState().User;

    let sp = account?.user?.selected_program;
    let newSelectedPrograms = "";
    let newP = programID + (level && level != 0 ? "-" + level : "");

    if (sp) {
        newSelectedPrograms = sp.split(",");
        newSelectedPrograms.push(newP);
        newSelectedPrograms = newSelectedPrograms.join(",");
    } else {
        newSelectedPrograms = [newP].join(",");
    }

    const res = await apiCallV2(
        "POST",
        "user/add-program",
        {
            selected_program: newSelectedPrograms,
            programID: programID,
            level: level,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status === 200 && res?.data.status == 200) {

        dispatch({
            type: SET_SELECTED_PROGRAM,
            data: newSelectedPrograms,
        });

        return {
            success: true,
        };
    } else {
        return {
            success: false,
            message: "Failed",
        };
    }
};

export const GetAllWorkOutHistories = () => async (dispatch, getState) => {
    const { allWorkoutHistory } = getState().User;

    // if (allWorkoutHistory.length == 0) {
    const res = await apiCallV2("GET", "get-all-workout-history-ids-only", "", localStorage.getItem("access-token"), undefined, false);
    if (res?.status == 200 && res?.data.status == 200) {
        dispatch({
            type: SET_USER_ALL_WORKOUT_HISTORY,
            list: [...res?.data.data.workouts],
        });
    }
    // } else {
    // }
};

export const GetAllWorkOutHistoriesWithArchived = () => async (dispatch, getState) => {
    const { allWorkoutHistory } = getState().User;
    // if (allWorkoutHistory.length == 0) {
    const res = await apiCallV2("GET", "get-all-workout-history-ids-only", "", localStorage.getItem("access-token"), { includeArchived: true }, false);

    if (res?.status == 200 && res?.data.status == 200) {
        dispatch({
            type: SET_USER_ALL_WORKOUT_HISTORY_WITH_ARCHIVED,
            list: [...res?.data.data.workouts],
        });
    }
    // } else {
    // }
};

export const ResetProgramActivity = (program) => async (dispatch, getState) => {
    const { allWorkoutHistory } = getState().User;
    const { groupedWorkouts } = getState().Workout;
    const res = await apiCallV2(
        "POST",
        "reset-program",
        {
            program: program.id,
            level: program.level,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status === 200) {
        const key = "prog-" + program.id + (program.level && program.level != 0 ? "-" + program.level : "");
        let firstWorkout = groupedWorkouts[key][0];

        let tempList = allWorkoutHistory.filter((wh) => !(wh.program == program.id && wh.level == program.level));

        dispatch({
            type: SET_USER_ALL_WORKOUT_HISTORY,
            list: [
                ...tempList,
                {
                    archived_at: null,
                    created_at: new Date(),
                    id: 9999999999999999999,
                    percentage: 0,
                    program: program.id,
                    level: program.level,
                    watchedtime: 0,
                    workout_id: firstWorkout.id,
                },
            ],
        });

        return true;
    } else {
        return false;
    }
};

export const DeleteSelectedProgram = (program) => async (dispatch, getState) => {
    const { allWorkoutHistory, account } = getState().User;
    const { groupedWorkouts } = getState().Workout;

    const res = await apiCallV2(
        "POST",
        "reset-program",
        {
            program: program.id,
            level: program.level,
            isDelete: true,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status === 200) {
        let tempList = allWorkoutHistory.filter((wh) => !(wh.program == program.id && wh.level == program.level));

        let selectedProgram = account?.user?.selected_program?.split(",");

        let key = program?.id + (program?.level && program?.level != 0 ? "-" + program?.level : "");
        selectedProgram = selectedProgram?.filter((sp) => sp != key);
        selectedProgram = selectedProgram?.join(",");

        const res2 = await apiCallV2(
            "POST",
            "user/add-program",
            {
                selected_program: selectedProgram,
                isDelete: true,
            },
            localStorage.getItem("access-token")
        );

        if (res2.status === 200 && res2.data.status == 200) {
            dispatch({
                type: SET_SELECTED_PROGRAM,
                data: selectedProgram,
            });

            dispatch({
                type: SET_USER_ALL_WORKOUT_HISTORY,
                list: [...tempList],
            });

            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

export const UpdateFavorite =
    (video, value, isWorkout = true) =>
        async (dispatch, getState) => {
            const res = await apiCallV2(
                "POST",
                "update-favorites",
                {
                    id: video.id,
                    is_favorite: value,
                    is_workout: isWorkout,
                },
                localStorage.getItem("access-token")
            );

            if (res?.status == 200) {
                let { workouts, exercises } = getState().User.favorites;
                let workoutsF = getState().Favorite.workouts;
                let exercisesF = getState().Favorite.exercises;

                if (isWorkout) {
                    let list = [];

                    if (value) {
                        workouts.push({ workout_id: video.id });
                        list = [...workoutsF, video];
                    } else {
                        workouts = workouts.filter((i) => i.workout_id !== video.id);
                        list = [...workoutsF.filter((i) => i.workout_id !== video.id)];
                    }

                    dispatch({
                        type: SET_FAVORITE_WORKOUTS,
                        list: list,
                    });
                } else {
                    if (value) {
                        exercises.push({ exercise_id: video.id });
                    } else {
                        exercises = exercises.filter((i) => i.exercise_id !== video.id);
                    }
                }

                dispatch({
                    type: SET_FAVORITES_IDS,
                    data: {
                        workouts: workouts,
                        exercises: exercises,
                    },
                });
            }
        };


export const GetSurveyGoals = (goals) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "GET",
        "get-survey-goals",
        {},
        localStorage.getItem("access-token")
    );

    if (res?.data?.status) {
        dispatch({
            type: SET_SURVEY_GOALS,
            list: res?.data?.data?.goals,
        });
    }
};

export const GetSurveyQuestions = (goals) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "survey-question",
        {
            goal_ids: goals,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200) {
        let { latestSurveyScores } = getState().User;
        const surveys = res?.data.data;
        let title, answer, id, key;

        if (latestSurveyScores) {
            for (let x = 0; x < surveys.length; x++) {
                title = surveys[x].title.split(" ").join("").toLowerCase();
                id = surveys[x].id;

                if (x < 3) {
                    key = `goal${x + 1}_score`;
                    answer = latestSurveyScores[key];
                } else {
                    answer = latestSurveyScores[title];

                    if (title == "perceivedhealth") {
                        title = "mental";
                        answer = latestSurveyScores[title];
                        answer = answer > 10 ? answer / 10 : answer;
                    }
                }

                surveys[x] = {
                    ...surveys[x],
                    answer: null,
                    latestAnswer: answer,
                };
            }
        }

        dispatch({
            type: SET_SURVEY_QUESTIONS,
            list: surveys,
        });
    }
};

export const SetAnswer = (survey, index, value) => async (dispatch, getState) => {
    let { surveyQuestions } = getState().User;

    surveyQuestions[index].answer = value;

    dispatch({
        type: SET_SURVEY_QUESTIONS,
        list: surveyQuestions,
    });
};

export const SubmitAnswers =
    (redo = false, redoType = "full") =>
        async (dispatch, getState) => {
            let route = "submit-survey";
            let { surveyQuestions, account } = getState().User;

            // const redo = localStorage.getItem("indi-redo-survey");
            // const redoType = localStorage.getItem("indi-redo-type");

            let goal1 = surveyQuestions.shift();
            let goal2 = surveyQuestions.shift();
            let goal3 = surveyQuestions.shift();

            let answers = {},
                key;

            if (redo && redoType == "half") {
                route = "submit-survey-half";
            }

            for (let x = 0; x < surveyQuestions.length; x++) {
                key = surveyQuestions[x].title.toLowerCase().split(" ").join("");

                answers[key] = {
                    score: surveyQuestions[x].answer,
                };
            }

            answers = {
                ...answers,
                goal1: {
                    id: goal1.id,
                    score: goal1.answer,
                },
                goal2: {
                    id: goal2.id,
                    score: goal2.answer,
                },
                goal3: {
                    id: goal3.id,
                    score: goal3.answer,
                },
            };

            const res = await apiCallV2(
                "POST",
                route,
                {
                    surveys: answers,
                },
                localStorage.getItem("access-token")
            );

            if (res?.status == 200) {
                await LoadAccountDetails()(dispatch, getState);

                dispatch({
                    type: SET_USER_DETAILS,
                    details: {
                        ...account?.user,
                        requirement_status: 3,
                    },
                });

                localStorage.setItem("requirement_status", 3);
                localStorage.removeItem("indi-skip-redo-survey");
                localStorage.removeItem("indi-skip-survey");
                localStorage.removeItem("indi-redo-survey");

                return {
                    success: true,
                };
            } else {
                return {
                    success: false,
                };
            }
        };

export const GetSelectionHistory =
    (program, level = null) =>
        async (dispatch, getState) => {
            const res = await apiCallV2("GET", "get-selected-programs", "", localStorage.getItem("access-token"), undefined, false);

            dispatch({
                type: SET_SELECTED_PROGRAMS,
                list: res?.data.data,
            });
        };

export const SendVerificationCode = (email, firstname, code) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "send-verification-code",
        {
            code: code,
            firstname: firstname,
            email: email.toLowerCase().trim(" "),
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200) {
        return true;
    } else {
        return false;
    }
};

export const UpdateAppSettings = (type, value) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "settings/update",
        {
            type: type,
            value: value,
        },
        localStorage.getItem("access-token")
    );
};

export const GetAppSettings = (e) => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "settings/get", "", localStorage.getItem("access-token"));

    if (res?.status == 200) {
        return true;
    } else {
        return false;
    }
};

export const GetInAppNotifications = () => async (dispatch, getState) => {
    const iap = await apiCallV2("GET", "in-app-notification/get", "", localStorage.getItem("access-token"));

    if (iap?.status == 200) {
        return iap?.data?.data?.id ? iap?.data?.data : null;
    } else {
        return null;
    }
};

export const InAppNotificationClicked = (id) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "in-app-notification/viewed",
        {
            ian: id,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200) {
        const { notifications } = getState().User;

        let temp = notifications.map((n) => {
            return {
                ...n,
                status: n?.type == "in-app" && n?.metadata?.ianID == id ? 1 : n.status,
            };
        });

        dispatch({
            type: SET_USER_NOTIFICATIONS,
            list: temp,
        });
    } else {
        return null;
    }
};

export const PushNotificationClicked = (id) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "push-notification/clicked",
        {
            notificationID: id,
        },
        localStorage.getItem("access-token")
    );

    if (res?.status == 200) {
        const { notifications } = getState().User;

        let temp = notifications.map((n) => {
            return {
                ...n,
                status: n?.type == "push" && n?.metadata?.pnlID == id ? 1 : n.status,
            };
        });

        dispatch({
            type: SET_USER_NOTIFICATIONS,
            list: temp,
        });
    } else {
        return null;
    }
};

export const ArrangeInAppNotifcation = (ian) => async (dispatch, getState) => {
    let { metadata, type, id } = ian;
    metadata = JSON.parse(metadata);

    let overlayData = {};

    const setupOverlay = (type, metadata, appearance) => {
        overlayData = {
            type: type,
            metadata: {
                ...metadata,
                appearance: appearance,
            },
            ianID: id,
        };
    };

    if (type == "workout-nth") {
        //metadata?.workout
        const gwdRes = await GetWorkoutDetails(metadata?.workout)();
        setupOverlay("ian", metadata, {
            gradient: gwdRes?.gradient?.split("-"),
            icon: {
                type: "number",
                svg: "n" + metadata?.numberOfWorkout,
            },
            title: metadata?.numberOfWorkout == 1 ? "You've completed your first workout" : `You've Completed ${metadata?.numberOfWorkout} Workouts`,
            progress: {
                workoutsCompleted: metadata?.numberOfWorkout,
                activeMinutes: Math.round(metadata?.accumulatedTime / 60),
            },
        });
    } else if (type == "program") {
        const gwdRes = await GetWorkoutDetails(metadata?.workout)();
        setupOverlay("ian", metadata, {
            gradient: gwdRes?.gradient?.split("-"),
            icon: {
                type: "program",
                svg: ["", "beginner", "moderate", "advanced"][gwdRes?.program_detail_id] + gwdRes?.svg,
            },
            title: `You Completed ${gwdRes?.title}${["", " - Beginner", " - Moderate", " - Advanced"][gwdRes?.program_detail_id]}`,
            progress: {
                workoutsCompleted: metadata?.numberOfWorkout,
                activeMinutes: Math.round(metadata?.accumulatedTime / 60),
            },
        });
    } else if (type == "challenge") {
        //metadata?.program.program_id
        //metadata?.workout
        setupOverlay("ian", metadata, {
            gradient: metadata?.completed?.gradient?.split("-"),
            icon: {
                type: "challenge",
                svg: metadata?.completed?.svg,
            },
            title: `You've Completed the ${metadata?.completed?.title}`,
            progress: {
                workoutsCompleted: metadata?.numberOfWorkout,
                activeMinutes: Math.round(metadata?.accumulatedTime / 60),
            },
        });
    } else if (type == "milestone") {
        let currentMilestone = metadata?.milestone?.milestone?.split("-")[metadata?.milestone?.currentMilestone - 1];
        setupOverlay("ian", metadata, {
            gradient: metadata?.milestone?.gradient?.split("-"),
            icon: {
                type: "challenge",
                svg: metadata?.milestone?.svg,
            },
            title: `You've Done ${currentMilestone} ${metadata?.milestone?.unit} of the ${metadata?.milestone?.title}`,
            progress: {
                workoutsCompleted: metadata?.numberOfWorkout,
                activeMinutes: Math.round(metadata?.accumulatedTime / 60),
            },
        });
    } else if (type == "streak") {
        const gwdRes = await GetWorkoutDetails(metadata?.workout)();
        setupOverlay("ian", metadata, {
            gradient: gwdRes?.gradient?.split("-"),
            icon: {
                type: "streak",
            },
            title: `You've Added to Your Streak`,
            progress: {
                workoutsCompleted: metadata?.numberOfWorkout,
                activeMinutes: Math.round(metadata?.accumulatedTime / 60),
            },
        });
    }

    return overlayData;
};

export const GetAllNotifications = (limit) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "GET",
        "in-app-notification/get-all",
        "",
        localStorage.getItem("access-token"),
        {
            limit: limit,
        },
        false
    );
    if (res?.status == 200) {
        const { inAppNotifications, pushNotifications } = res?.data?.data;
        const pnTitle = {
            "jeopardising-streak-reminder": "Jeopardising Streak Reminder",
            "hit-streak-reminder": "Hit Streak Reminder",
            "inactive-new-user": "Time to Get Moving!",
            "inactivity-1st": "Time to Get Moving!",
            "inactivity-3rd": "Time to Get Moving!",
            "inactivity-2nd": "Time to Get Moving!",
        };
        const duplicateIndicator = [];

        let list = [],
            md,
            title = "",
            icon = {},
            description = "",
            repeat = false;

        for (let x = 0; x < inAppNotifications.length; x++) {
            md = await ArrangeInAppNotifcation(inAppNotifications[x])();
            list.push({
                title: md?.metadata?.appearance?.title || "",
                description: "",
                metadata: md,
                date: new Date(inAppNotifications[x]?.date),
                type: "in-app",
                status: inAppNotifications[x]?.status,
                icon: {
                    type: md?.metadata?.appearance?.icon?.svg ? md?.metadata?.appearance?.icon?.type : "main",
                    name: md?.metadata?.appearance?.icon?.svg || md?.metadata?.appearance?.icon?.type,
                },
                gradient: md?.metadata?.appearance?.gradient.join("-") || "#d37536-#d37536",
            });
        }

        for (let x = 0; x < pushNotifications.length; x++) {
            repeat = false;
            description = "";
            title = pnTitle[pushNotifications[x]?.notificationType];
            icon = {
                type: "main",
                name: pushNotifications[x]?.notificationType,
            };

            if (!title) {
                if (pushNotifications[x]?.notificationType == "new-program") {
                    title = `New program alert! Check out ${pushNotifications[x]?.programTitle} Program today!`;
                    icon = {
                        type: "program",
                        name: pushNotifications[x]?.programSvg,
                    };
                } else if (pushNotifications[x]?.notificationType == "new-challenge") {
                    title = `New challenge alert! Check out ${pushNotifications[x]?.challengeTitle} today!`;
                    icon = {
                        type: "challenge",
                        name: pushNotifications[x]?.challengeSvg,
                    };
                }
            } else {
                if (duplicateIndicator.includes(title)) {
                    repeat = true;
                } else {
                    duplicateIndicator.push(title);
                }
                description = pushNotifications[x]?.message;
            }

            if (!repeat) {
                list.push({
                    title: title,
                    description: description,
                    metadata: {
                        pnlID: pushNotifications[x]?.pnlID,
                        ...JSON.parse(pushNotifications[x]?.metadata),
                        programID: pushNotifications[x]?.programID,
                        notificationType: pushNotifications[x]?.notificationType,
                    },
                    date: new Date(pushNotifications[x]?.dateSent),
                    type: "push",
                    status: pushNotifications[x]?.pnlStatus,
                    icon: icon,
                    gradient: pushNotifications[x]?.programGradient || pushNotifications[x]?.challengeGradient || "#d37536-#d37536",
                });
            }
        }

        list = list?.sort((a, b) => b.date - a.date);

        dispatch({
            type: SET_USER_NOTIFICATIONS,
            list: list || [],
        });
    }
};

export const SetAccountDetails =
    (data) =>
        async (dispatch) => {
            dispatch({
                type: SET_ACCOUNT_DETAILS,
                details: {
                    ...data,
                },
            });
        };

export const LoadAccountDetails =
    (isReturn = false, type = 0) =>
        async (dispatch) => {
            const token = localStorage.getItem("access-token") || localStorage.getItem("temp-access-token")
            const res = await apiCallV2("GET", "load-account-details", "", token, "", false);
            if (type == 1) {
            }

            if (res?.status == 200) {
                if (isReturn) {
                    return {
                        ...res?.data?.data,
                    };

                } else {
                    dispatch({
                        type: SET_ACCOUNT_DETAILS,
                        details: {
                            ...res?.data?.data,
                        },
                    });
                    return true;
                }
            } else if (!res?.status || !res?.data) {
                const res2 = await apiCallV2("GET", "load-account-details", "", token, "", false);
                if (type == 1) {
                }

                if (res2?.status == 200) {
                    if (isReturn) {
                        return {
                            ...res?.data?.data,
                        };

                    } else {
                        dispatch({
                            type: SET_ACCOUNT_DETAILS,
                            details: {
                                ...res?.data?.data,
                            },
                        });
                        return true;
                    }
                }

            } else {
                return false;
            }
        };

export const CheckRequirementsAndRedirectV2 = (navigate) => async (dispatch, getState) => {
    const { account } = getState().User;
    const isUsingMobileApp = checkIfUsingMobileApp();
    const hasLiveSubscription = account?.billingInfo?.hasLiveSubscription;

    // Check impact fragment
    if (checkImpactFrag()) {
        navigate("/signup");
        return true;
    }

    // Check if user already undergone the new survey
    if (account?.onboardingDetails?.length === 0) {
        navigate("/user-survey")
    }

    // Check Company Subscription
    let launchDate = account?.user?.launchDate; // || localStorage.getItem("launchDate");
    if (launchDate) {
        launchDate = new Date(launchDate);
        launchDate.setHours(0, 0, 0, 0);
        if (new Date() < launchDate && account?.billingInfo && !hasLiveSubscription) {
            localStorage.setItem("expired", true);
            if (isUsingMobileApp) {
                callSocket("/interact-native-component", { type: "screens", subtype: "show-billing" });
                // logoutAndRedirectMain(navigate);
            } else {
                navigate(process.env.PUBLIC_URL + "/choose-plan");
            }
            return false;
        }
    }

    // Check if account is Expired
    if (account?.billingInfo && !hasLiveSubscription) {
        localStorage.setItem("expired", true);
        if (isUsingMobileApp) {
            callSocket("/interact-native-component", { type: "screens", subtype: "show-renew" });
            // logoutAndRedirectMain(navigate);
        } else {
            navigate(process.env.PUBLIC_URL + "/renew");
        }

        return false;
    }

    // Check if Redo Survey

    const redoSurvey = checkIfRedoSurvey(account?.surveys);
    // if (redoSurvey) {
    //     if (redoSurvey.type === "full") {
    //         navigate(process.env.PUBLIC_URL + "/getting-started", {
    //             state: { steps: 1 },
    //         });
    //     } else if (redoSurvey.type === "half") {
    //         navigate(process.env.PUBLIC_URL + "/getting-started", {
    //             state: { steps: 1 },
    //         });
    //     }
    // }

    // Onboarding Check Points
    const hasUsernamePassword = account?.user?.user_name && (account?.user?.password || account?.user?.auth_provider) ? true : false;
    const doneSurvey = account?.surveys?.length > 0;
    const skipProgramSelection = localStorage.getItem("skip-program-selection");
    const selectedAProgram = account?.selectedPrograms?.length > 0 || skipProgramSelection;
    const selectedAPlan = account?.billingInfo && account?.subscription;
    const filledBasicInfo = account?.user?.first_name && account?.user?.last_name && account?.user?.dob && account?.user?.gender;


    // if (hasUsernamePassword && !doneSurvey && !selectedAProgram && !selectedAPlan && !filledBasicInfo) {
    if (hasUsernamePassword && !filledBasicInfo) {
        // navigate(process.env.PUBLIC_URL + "/getting-started");
        navigate(process.env.PUBLIC_URL + "/personal-info");
        return false;
        // } else if (hasUsernamePassword && doneSurvey && !selectedAProgram && !selectedAPlan && !filledBasicInfo) {
    } else if (hasUsernamePassword && filledBasicInfo && !doneSurvey) {
        // navigate(process.env.PUBLIC_URL + "/getting-started");
        return false;
        // } else if (hasUsernamePassword && doneSurvey && selectedAProgram && !selectedAPlan && !filledBasicInfo) {
        // } else if (hasUsernamePassword && filledBasicInfo && doneSurvey && !selectedAProgram) {
        //     navigate(process.env.PUBLIC_URL + "/program-introduction");
        //     return false;
    } else if (hasUsernamePassword && filledBasicInfo && doneSurvey && selectedAProgram && !selectedAPlan) {
        if (isUsingMobileApp) {
            const isPaid = localStorage.getItem("is-paid"); //force value from mobile webview to identify that user comes from billing page
            if (isPaid != 1) {
                callSocket("/interact-native-component", { type: "screens", subtype: "show-billing" });
            }
        } else {
            navigate(process.env.PUBLIC_URL + "/choose-plan");
        }
        return false;
    }
};

export const CheckRequirementsAndRedirect =
    (status, navigate, area = "inside", offer) =>
        async (dispatch, getState) => {
            status = status ? status * 1 : status;
            const irclickid = localStorage.getItem("irclickid");
            const accessToken = localStorage.getItem("access-token");

            if (irclickid && !accessToken) {
                navigate("/signup");
                return true;
            }

            const requirementStatus = {
                ONLY_EMAIL_PASS: 0,
                WITH_BILLING: 1,
                WITH_NAME_BOD_GEND: 2,
                DONE_SURVEY: 3,
            };

            const dt = localStorage.getItem("indi-device-type");
            const platform = localStorage.getItem("indi-platform");
            const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");

            // (dt !== "ios" && dt !== "android" && dt !== "mobile")

            const expired = localStorage.getItem("indi-skip-redo-survey");
            const isSkipSurvey = localStorage.getItem("indi-skip-survey");
            const isRedoSurvey = localStorage.getItem("indi-redo-survey");
            let skipSurveyRedoDate = localStorage.getItem("indi-skip-survey-repeat-date");

            //Checking company listed users livedate
            const token = localStorage.getItem("access-token");
            const hasLiveSubscription = expired ? false : await HasLiveSubscription()();
            let info = localStorage.getItem(token);

            let launchDate = localStorage.getItem("launchDate");
            if (info || launchDate) {
                info = JSON.parse(info);
                launchDate = launchDate ? new Date(launchDate) : new Date(info.launchDate);
                launchDate.setHours(0, 0, 0, 0);

                if (new Date() < launchDate && hasLiveSubscription) {
                    // navigate("/");
                    // return true;
                } else if (new Date() < launchDate && !hasLiveSubscription) {
                    localStorage.setItem("expired", true);

                    if (isUsingApp) {
                        // navigate("/inactive");
                        logoutAndRedirectMain(navigate);
                    } else {
                        navigate(process.env.PUBLIC_URL + (offer ? `/choose-plan?offer=${offer}` : "/choose-plan"));
                        // logoutAndRedirectMain(navigate);
                    }

                    // return false;
                }
            }

            if (!hasLiveSubscription && status === requirementStatus.DONE_SURVEY) {
                localStorage.setItem("expired", true);

                if (isUsingApp) {
                    // navigate("/inactive");
                    logoutAndRedirectMain(navigate);
                } else {
                    navigate(process.env.PUBLIC_URL + (offer ? `/renew?offer=${offer}` : "/renew"));
                    // logoutAndRedirectMain(navigate);
                }

                return false;
            }

            // Will check survey redo
            skipSurveyRedoDate = skipSurveyRedoDate ? new Date(skipSurveyRedoDate) : false;
            const currDate = new Date();
            if (isRedoSurvey === null || (isRedoSurvey && !isSkipSurvey) || (isRedoSurvey && isSkipSurvey && currDate >= skipSurveyRedoDate)) {
                // if (isRedoSurvey === null || (isRedoSurvey && !isSkipSurvey)) {
                const redoSurvey = await CheckIfRedoSurvey()();
                if (redoSurvey) {
                    localStorage.setItem("indi-redo-survey", true);
                    localStorage.setItem("indi-redo-type", redoSurvey.type);

                    if (redoSurvey.type === "full") {
                        navigate(process.env.PUBLIC_URL + "/getting-started", {
                            state: { steps: 1 },
                        });
                    } else if (redoSurvey.type === "half") {
                        navigate(process.env.PUBLIC_URL + "/getting-started", {
                            state: { steps: 1 },
                        });
                    }
                    return false;
                }
            }

            if (status === "null" || status === null) {
                if (area == "login") {
                    navigate(process.env.PUBLIC_URL + "/home");
                }
                return true;
            }

            status = status * 1;

            if (status === requirementStatus.ONLY_EMAIL_PASS) {
                navigate(process.env.PUBLIC_URL + (offer ? `/choose-plan?offer=${offer}` : "/choose-plan"));
                // logoutAndRedirectMain(navigate);
                return false;
            } else if (status === requirementStatus.WITH_BILLING) {
                navigate(process.env.PUBLIC_URL + "/getting-started");
                return false;
            } else if (status === requirementStatus.WITH_NAME_BOD_GEND) {
                navigate(process.env.PUBLIC_URL + "/getting-started", {
                    state: { steps: 3 },
                });
                return false;
            } else if (status === requirementStatus.DONE_SURVEY) {
                if (area == "login") {
                    navigate(process.env.PUBLIC_URL + "/home");
                }
                return true;
            }
        };

export const AddUserLocation = (data) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "add-user-location",
        {
            ...data,
        },
        localStorage.getItem("access-token")
    );
};

export const SetPersonalInfo = (details) => async (dispatch, getState) => {
    const { account } = getState().User;
    dispatch({
        type: SET_ACCOUNT_DETAILS,
        details: {
            ...account,
            user: {
                ...account?.user,
                dob: details?.dob,
                gender: details?.gender,
                last_name: details?.last_name,
                first_name: details?.first_name,
            },
        },
    });
};


export const SetInvitationDetails = (data) => async (dispatch, getState) => {
    dispatch({
        type: SET_INVITATION_DETAILS,
        details: data,
    });
};

export const GetPatientEmailDetails = (emailId) => async (dispatch, getState) => {

    const res = await servicesAPICall(
        "GET",
        "clinicient/get-patient-email-details",
        "",
        localStorage.getItem("access-token"),
        {
            emailId: emailId,
        },
        false
    );

    dispatch({
        type: SET_PATIENT_EMAIL_DETAILS,
        details: res?.data?.data?.[0] || null,
    });

    return res;
};

export const EmailInvitationRegistered = (event_id) => async (dispatch, getState) => {
    const res = await servicesAPICall(
        "POST",
        "clinicient/paubox-email-webhook-registered",
        {
            event_id: event_id,
        },
        localStorage.getItem("access-token") || localStorage.getItem("temp-access-token")
    );
    return res;
};

export const UserOnboarding = (preRegistrationDetails) => async (dispatch, getState) => {
    const res = await apiCallV2("POST", "user/onboarding", { ...preRegistrationDetails });


    if (res?.data?.status == 200) {
        localStorage.setItem("temp-access-token", res?.data?.data?.access_token);
        localStorage.setItem("onboarding-user-id", res?.data?.data?.userid);
        return res?.data?.data?.userid || false;
    } else if (!res?.data?.status || !res?.status) {
        const res2 = await apiCallV2("POST", "user/onboarding", { ...preRegistrationDetails });
        if (res2?.data?.status == 200) {
            localStorage.setItem("temp-access-token", res2?.data?.data?.access_token);
            localStorage.setItem("onboarding-user-id", res2?.data?.data?.userid);
            return res2?.data?.data?.userid || false;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

export const GenerateSchedule = (preRegistrationDetails) => async (dispatch, getState) => {

    const res = await servicesAPICall(
        "POST",
        "onboarding/generate-user-schedule-direct",
        {
            ...preRegistrationDetails
        },
    );


    if (res?.data?.status == 200) {
        localStorage.setItem("onboarding-details", JSON.stringify({
            ...preRegistrationDetails,
        }));

        localStorage.setItem("onboarding-suggested-schedule", res?.data?.data?.schedule);

        return res?.data?.data?.schedule || false;
    } else if (!res?.data?.status || !res?.status) {
        const res2 = await servicesAPICall(
            "POST",
            "onboarding/generate-user-schedule-direct",
            {
                ...preRegistrationDetails
            },
        );
        if (res2?.data?.status == 200) {
            localStorage.setItem("onboarding-details", JSON.stringify({
                ...preRegistrationDetails,
            }));
            localStorage.setItem("onboarding-suggested-schedule", res2?.data?.data?.schedule);

            return res2?.data?.data?.schedule || false;
        } else {
            return false;
        }
    } else {
        return false;
    }

};

export const GenerateScheduleOldUser = (preRegistrationDetails) => async (dispatch, getState) => {
    try {

        const res = await servicesAPICall(
            "POST",
            "onboarding/generate-user-schedule-direct-old-user-v2",
            {
                ...preRegistrationDetails
            },
            localStorage.getItem("access-token"),
        );


        if (res?.data?.status == 200) {
            return res?.data?.data?.schedule || false;
        } else if (!res?.data?.status || !res?.status) {
            const res2 = await servicesAPICall(
                "POST",
                "onboarding/generate-user-schedule-direct-old-user-v2",
                {
                    ...preRegistrationDetails
                },
                localStorage.getItem("access-token"),
            );
            if (res2?.data?.status == 200) {
                return res2?.data?.data?.schedule || false;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } catch (e) {
    }

};

export const LinkScheduleToUser = (scheduleID, userID) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "user/link-schedule-to-user",
        {
            userID, scheduleID
        },
        localStorage.getItem("temp-access-token")
    );

    return res;
};


export const GetNextWorkout = (programID, previousWorkouts, offset = 1) => async (dispatch, getState) => {

    const { workouts } = getState().Program

    if (!workouts[programID]?.length) {
        const res = await apiCallV2(
            "GET",
            "user/get-next-workout",
            "",
            localStorage.getItem("access-token") || localStorage.getItem("temp-access-token"),
            {
                programID: programID,
                previousWorkouts: previousWorkouts,
            },
            false
        );

        dispatch({
            type: SET_PROGRAM_WORKOUTS,
            data: {
                key: programID,
                list: res?.data?.data || [],
            }
        })

        return res?.data?.data?.[offset - 1] || {};
    } else {
        const tempIDs = previousWorkouts.map((i) => {
            return {
                id: i
            }
        });
        const programWorkouts = [...workouts[programID]];
        const filteredWorkouts = removeItemInArray(programWorkouts, tempIDs, ["id"]);
        return filteredWorkouts?.[offset - 1] || {};
    }
}


export const LinkInvitationDetails = (invitationDetails) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "user/link-invitation-details",
        {
            ...invitationDetails,
        },
        localStorage.getItem("access-token") || localStorage.getItem("temp-access-token")
    );
    return res;
};

export const LogGenerateLink = () => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "user/log-generate-link",
        {},
        localStorage.getItem("access-token")
    );
    return res;
};
